// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { updateHighlightedPaths } from 'redux/modules/projectSummary'

const togglePathHighlight = pathId => (dispatch, getState) => {
  const highlightedPaths = getState().projectSummary.get('highlightedPaths')

  // look for the index of this pathId in the current list of highlightedPaths
  const indexInSelectedPaths = highlightedPaths.indexOf(pathId)

  // if the pathId wasn't in the list, then add it
  // otherwise remove the thing
  const updatedHighlightedPaths = (
    !~indexInSelectedPaths
      ? highlightedPaths.push(pathId)
      : highlightedPaths.delete(indexInSelectedPaths)
  )

  dispatch(updateHighlightedPaths(updatedHighlightedPaths))
}

export default togglePathHighlight
